import { Component, OnDestroy, OnInit } from '@angular/core';
import { ICON_TYPE, ViewModes } from '@spartacus/storefront';
import { FacetSortService } from '../product-facet-navigation/facet-sort.service';
import { Subscription, map } from 'rxjs';

@Component({
  selector: 'cx-product-view',
  templateUrl: './product-view.component.html',
  styleUrl: './product-view.component.scss',
  standalone: false,
})
export class CustomProductViewComponent implements OnInit, OnDestroy {
  ICON_TYPE = ICON_TYPE;
  ViewModes = ViewModes;
  currentViewMode$ = this.facetSortService.currentViewMode$;
  otherOption$ = this.currentViewMode$.pipe(
    map((viewMode: ViewModes) => {
      return viewMode?.toString()?.toUpperCase() === ViewModes.Grid.toUpperCase() ? ViewModes.List : ViewModes.Grid;
    }),
  );

  subscriptions = new Subscription();

  constructor(private facetSortService: FacetSortService) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.facetSortService.viewModeByTemplate$.subscribe((viewMode: ViewModes) => {
        this.facetSortService.currentViewMode$.next(viewMode);
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  changeMode() {
    const newMode = this.currentViewMode$.getValue() === ViewModes.Grid ? ViewModes.List : ViewModes.Grid;
    this.facetSortService.currentViewMode$.next(newMode);
  }
}
